export default function getPickupState(snapshot, pendingPickup = null) {
    const selection = pendingPickup ?? snapshot.selection;
    const locations = selection.method ? snapshot.locations[selection.method] : [];
    const location = locations.find(item => item.id === selection.id);
    const methods = [];
    if (snapshot.locations.store.length)
        methods.push('store');
    if (snapshot.locations.reseller.length && !snapshot.availabilityError)
        methods.push('reseller');
    const availabilityError = selection.method === 'reseller' || methods.length === 0 ? snapshot.availabilityError || null : null;
    return {
        selection,
        locations,
        location,
        methods,
        resellers: snapshot.availabilityError
            ? snapshot.locations.reseller.filter(item => selection.method === 'reseller' && item.id === selection.id)
            : snapshot.locations.reseller,
        availabilityError,
        noLocations: methods.length === 0 && !snapshot.availabilityError,
        locationDisabled: selection.method === 'reseller' && Boolean(snapshot.availabilityError),
    };
}
